import { Either } from "core/types/Either";

export default abstract class UseCase<Type, Params> {
  abstract execute(params: Params): Promise<Either<Error, Type>>;
}

export class NoParams {}
